import {isPermissionActive, type Permission} from '../pages/permissions/permissionMetadata'

// Rotas anteriores ao cadastro do campo route e nomes legados ainda presentes na base.
const legacyRoutes: Record<string, string[]> = {
  'cashback-lojas-participantes-view': ['/lojas', '/ul-programas'],
  'unilever-lojas-participantes-view': ['/lojas', '/ul-programas'],
  'cashback-listas-view': ['/listas'],
  'cashback-regionais-view': ['/regionais'],
  'cashback-tamanhos-view': ['/tamanhos'],
  'cashback-bus-view': ['/bus'],
  'cashback-tabela-valores-view': ['/precos'],
  'cashback-cupons-view': ['/cupons'],
  'cashback-logs-view': ['/logs'],
  'cashback-alert-view': ['/alerts'],
  'cashback-validacoes-ass-promoid-cupomdescid-view': ['/validacoes/promo_cupom'],
  'cashback-validacoes-comp-benef-valorxvalor': ['/validacoes/comparacao_beneficio_valor'],
  'unilever-regionais-view': ['/ul-regionais'],
  'unilever-tamanhos-view': ['/ul-tamanhos'],
  'unilever-metas-unilever': ['/ul-metas'],
  'api-manage-users': ['/api/manage-users'],
  'api-manage-services': ['/api/manage-services'],
  'devops-dashboard': ['/devops/dashboard'],
  'devops-tasks': ['/devops/tarefas', '/devops/quadros'],
  'devops-users': ['/devops/usuarios'],
  'devops-sprints': ['/devops/sprints'],
  'devops-teams': ['/devops/equipes'],
  'development-features-manage': ['/development-features'],
  'ai-view': ['/ai'],
  'nps-view': ['/nps'],
  'users-view': ['/users'],
  'logs-view': ['/logs'],
  'analytics-view': ['/analytics'],
  'fechamentos-view': ['/fechamentos'],
  'campaign-simulator-view': ['/campaigns'],
}

export function normalizeFeaturePath(route: string) {
  try {
    route = decodeURIComponent(route)
  } catch {
    /* O roteador trata URLs inválidas. */
  }
  return (
    '/' +
    route
      .trim()
      .replace(/^\/+|\/+$/g, '')
      .replace(/\/\*$/, '')
      .toLowerCase()
  )
}

function matchesPath(pathname: string, route: string) {
  return pathname === route || pathname.startsWith(route + '/')
}

function screenRoutes(permission: Permission): string[] {
  // Estes módulos já protegem cada tela/ação internamente. Sua permissão de entrada
  // é verificada abaixo, mesmo quando outra permissão de uma tela permanece ativa.
  if (/^(agent-studio|platform-review)-/.test(permission.name)) return []
  const legacy =
    legacyRoutes[permission.name] || legacyRoutes[permission.name.replace(/-view$/, '')]
  if (legacy) return legacy
  const report = permission.name.match(
    /^cashback-relatorios-(positivacao|ativacao|lojistas|cupons|apuracao)(?:-|$)/
  )
  if (report) return ['/relatorios/' + report[1]]
  if (
    !permission.route ||
    /-(add|create|edit|update|delete|remove|execute|decide|request|export|upload)(-|$)/.test(
      permission.name
    )
  )
    return []
  return [normalizeFeaturePath(permission.route)]
}

export function findUnavailableFeature(
  pathname: string,
  catalog: Permission[],
  effective: Permission[]
) {
  const path = normalizeFeaturePath(pathname)
  const moduleAccess = catalog.find(
    (permission) =>
      !isPermissionActive(permission) &&
      ((permission.name === 'agent-studio-view' && matchesPath(path, '/agent-studio')) ||
        (permission.name === 'platform-review-view' && matchesPath(path, '/platform-review')))
  )
  if (moduleAccess) return moduleAccess
  const disabled = catalog
    .flatMap((permission) =>
      isPermissionActive(permission)
        ? []
        : screenRoutes(permission)
            .filter((route) => matchesPath(path, route))
            .map((route) => ({permission, route}))
    )
    .sort((a, b) => b.route.length - a.route.length)
  return disabled.find(
    ({route}) =>
      !effective.some(
        (permission) => isPermissionActive(permission) && screenRoutes(permission).includes(route)
      )
  )?.permission
}
